import { defineComponent as _defineComponent } from 'vue'
import { Dropdown } from '@shared/ui';
    import useNightsRangeDropdown from '../lib/useNightsRangeDropdown';
    import NightsRangeSelector from './NightsRangeSelector.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NightsRangeDropdown',
  props: {
    modelPrefix: null
  },
  setup(__props: any) {

const props = __props as { modelPrefix: string }

    

    const {
        nightRange,
        updateStoreNightRangeFrom,
        updateStoreNightRangeTo,
        checkInDateRangeLabel,
        nightsLabel,
    } = useNightsRangeDropdown(props);

return { __sfc: true,props, nightRange, updateStoreNightRangeFrom, updateStoreNightRangeTo, checkInDateRangeLabel, nightsLabel, Dropdown, NightsRangeSelector }
}

})